import { render, staticRenderFns } from "./program-status.vue?vue&type=template&id=e80d4b1e&"
import script from "./program-status.vue?vue&type=script&lang=js&"
export * from "./program-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports